export function definePanel(ymaps) {
    ymaps.modules.define('Panel', [
        'util.augment',
        'collection.Item',
    ], (provide, augment, item) => {
        const Panel = function (options) {
            Panel.superclass.constructor.call(this, options);
        };
        augment(Panel, item, {
            async onAddToMap(map) {
                await Panel.superclass.onAddToMap.call(this, map);
                const parentDomContainer = await this.getParent().getChildElement(this);
                this._$control = $('<div class="customControl"></div>').appendTo(parentDomContainer);
            },

            onRemoveFromMap(oldMap) {
                if (this._$control) {
                    this._$control.remove();
                }
                Panel.superclass.onRemoveFromMap.call(this, oldMap);
            },

            _onClose() {
                $('.customControl').css('display', 'none');
            },

            async setContent(text) {
                if (typeof this._$control === 'undefined') {
                    const parentDomContainer = await this.getParent().getChildElement(this);
                    this._$control = $('<div class="customControl"></div>').appendTo(parentDomContainer);
                }
                this._$control.css('display', 'flex');
                this._$control.html(text);
                $('.js-close-card').on('click', this._onClose);
            },
        });

        provide(Panel);
    });
}

/*
нужно передавать контекст,
пример requirePanel.call(this, ymaps, map);
*/
export async function requirePanel(ymaps, map) {
    await ymaps.modules.require(['Panel'])
        .spread(
            (Panel) => {
                ymaps.Panel = Panel;
                this.hotelMapPanel = new ymaps.Panel();
                map.controls.add(this.hotelMapPanel, {
                    float: 'left',
                });
            },
            this,
        );
}

export function getLeftHalfCenterPosition(mapWindow, bounds, markerCoordinates) {
    const mapWidth = mapWindow.width();
    const mapHeight = mapWindow.height();
    const lngDiff = mapWidth < 1000 ? (bounds[1][1] - bounds[0][1]) / 6 : (bounds[1][1] - bounds[0][1]) / 12;
    const heightDiff = mapHeight < 800 ? 0 : (bounds[1][0] - bounds[0][0]) / 6;
    return [markerCoordinates[0] - heightDiff, markerCoordinates[1] + lngDiff];
}

export default {
    definePanel,
    requirePanel,
    getLeftHalfCenterPosition,
};